import React from "react";
import { Box, Divider } from "@material-ui/core";
import { StageCard } from "./StageCard";
import { useDialogStyles } from "../styles/dialogStyles";
import { TFunction } from "i18next";

interface StagesSectionProps {
    stages: Compleo.JobApproval.stageWithApproversStatus[];
    t: TFunction;
    jobStatus: CompleoShared.Common.JobStatus;
}

export function StagesSection({ stages, t, jobStatus }: StagesSectionProps) {
    const classes = useDialogStyles();

    return (
        <div className={classes.stagesContainer}>
            {stages.map((stage, index) => (
                <Box key={stage.id || index}>
                    <StageCard
                        stage={stage}
                        stageIndex={index}
                        t={t}
                        jobStatus={jobStatus}
                    />
                    {index < stages.length - 1 && (
                        <Divider className={classes.stageDivider} />
                    )}
                </Box>
            ))}
        </div>
    );
}
